import {ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, Input} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {LanguageModule} from '../../../../language/language.module';
import {MatFormFieldModule} from '@angular/material/form-field';
import {takeWhile} from 'rxjs/operators';
import {AsyncPipe} from '@angular/common';
import {Observable} from 'rxjs';

@Component({
  selector: 'ctrl-attribute-flow-error-messages',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (_control.hasError('uniqueDestination')) {
      <mat-error>
        <language
          key="CtrlAttributeFlowUniqueDestinationError"
          defaultValue="There are multiple flows with the same destination. Destination must be unique."
        ></language>
      </mat-error>
    }
    @if (_control.hasError('incompleteFlows')) {
      <mat-error>
        <language
          key="CtrlAttributeFlowIncompleteFlowsError"
          defaultValue="There are incomplete flows. Please fill out all required fields or remove these rows."
        ></language>
      </mat-error>
    }
  `,
  imports: [LanguageModule, MatFormFieldModule],
})
export class CtrlAttributeFlowErrorMessagesComponent {
  private changeDetectorRef = inject(ChangeDetectorRef);

  _control: UntypedFormControl;
  @Input() set control(control: UntypedFormControl) {
    this._control = control;
    control.valueChanges
      .pipe(takeWhile(() => this._control === control))
      .subscribe(() => this.changeDetectorRef.markForCheck());
    this.changeDetectorRef.markForCheck();
  }
}

@Component({
  selector: 'ctrl-attribute-flow-title',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (title || (enabled | async) === true) {
      <div>
        <h4>{{ title | async }}</h4>
        <ctrl-attribute-flow-error-messages
          [control]="control"
        ></ctrl-attribute-flow-error-messages>
      </div>
    }
  `,
  imports: [AsyncPipe, CtrlAttributeFlowErrorMessagesComponent],
})
export class CtrlAttributeFlowTitleComponent {
  @Input() title: Observable<string> = null;
  @Input() enabled: Observable<boolean>;
  @Input() control: UntypedFormControl;
}
